import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './UserEditReviews.css';

// Component
import Loader from '../../../components/Loader/Loader';
import UserReviewsForm from '../../../components/siteadmin/UserReviewsForm';

// Query
import editAdminReviewsQuery from './editUserReview.graphql';
import { withQuery } from '../../../hoc/withGraphql';

class UserEditReviews extends React.Component {

    static propTypes = {
        title: PropTypes.string.isRequired,
        reviewId: PropTypes.number.isRequired
    };

    static defaultProps = {
        data: {
            loading: true
        }
    };

    render() {
        const { data: { loading, editUserReviews }, title, reviewId } = this.props;
        if (loading) {
            return <Loader type={"text"} />
        } else {
            return (
                <UserReviewsForm title={title} initialValues={editUserReviews} />
            );
        }
    }
}

export default compose(
    withStyles(s),
    withQuery(editAdminReviewsQuery,
        {
            options: (props) => ({
                variables: {
                    reviewId: props.reviewId,
                },
                fetchPolicy: 'network-only',
                ssr: false
            })
        }
    )
)(UserEditReviews);